import React from 'react';

import styled from '@emotion/styled';
import { mq } from '../../_style';

const Container = styled.div`
  h3 {
    font-weight: bold;
    margin-top: 10px;
    padding-bottom: 30px;
    p + &,
    small + & {
      padding-top: 30px;
    }
  }
  p + p {
    padding-top: 1.75em;
  }
  small {
    padding-top: 16px;
    & + p {
      padding-top: 16px;
    }
  }
  figure {
    font-size: 0;
    > * {
      border-radius: 4px;
      overflow: hidden;
    }
  }
  * + figure {
    ${mq.pc} {
      padding-top: 60px;
    }
    ${mq.sp} {
      padding-top: 45px;
    }
  }
  figure + * {
    padding-top: 30px;
  }
  img {
    width: 100%;
  }
`;

export default class TextBlock extends React.Component {
  render() {
    return <Container>{this.props.children}</Container>;
  }
}
